import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { SignUpUser } from 'src/app/store/auth/auth.models';
import Auth from '@aws-amplify/auth';
import { Router } from '@angular/router';


@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent  {
  cognitoUser: any = null;
  message: string = null;

  authLoading: Observable<boolean>;
  authError: Observable<string>;
  authState = 'LOGIN';
  authMessage: Observable<string>;

  signUpForm = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};

  confirmationForm = new FormGroup({});
  confirmationModel: any = {};
  confirmationFormField: FormlyFieldConfig[] = [
    {
      key: 'code',
      type: 'input',
      templateOptions: {
        required: true,
        type: 'text',
        label: 'Confirmation Code',
        appearance: 'outline'
      }
    }
  ];

  fields: FormlyFieldConfig[] = [
    {
      key: 'address',
      wrappers: ['firstWrapper'],
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'firstName',
          type: 'input',
          defaultValue: null,
          templateOptions: {
            required: true,
            type: 'text',
            label: 'First Name',
            appearance: 'outline',
          },
        },
        {
          key: 'lastName',
          type: 'input',
          defaultValue: null,
          templateOptions: {
            required: true,
            type: 'text',
            label: 'Last Name',
            appearance: 'outline',
          },
        },
      ],
    },
    {
      key: 'email',
      type: 'input',
      defaultValue: null,
      templateOptions: {
        required: true,
        type: 'email',
        label: 'Email Address',
        appearance: 'outline',
      },
    },
    {
      key: 'passwordGroups',
      wrappers: ['firstWrapper'],
      fieldGroup: [
        {
          key: 'password',
          type: 'input',
          defaultValue: null,
          templateOptions: {
            required: true,
            type: 'password',
            label: 'password',
            appearance: 'outline',
          },
        },
        {
          key: 'repeatPassword',
          type: 'input',
          defaultValue: null,
          templateOptions: {
            required: true,
            type: 'password',
            label: 'Repeat Password',
            appearance: 'outline',
          },
        },
      ],
    },
  ];
  constructor(private router: Router) { }


  submit(): void {
    if (this.signUpForm.valid) {
      const userData: SignUpUser = {
        username: this.model.email,
        password: this.model.passwordGroups.password,
        attributes: {
          email: this.model.email,
          given_name: this.model.address.firstName,
          family_name: this.model.address.lastName
        }
      };
      Auth.signUp(userData)
        .then((res) => {
          this.cognitoUser = res;
          this.authState = 'CONFIRM_SIGN_UP';
          this.message = `A confirmation code has been sent to you via ${res.codeDeliveryDetails.AttributeName} to ${res.codeDeliveryDetails.Destination}`;
        })
        .catch((error) => {
          this.authError = error.response.message;
        })
    }
  }

  confirmAccount(): void {
    if (this.confirmationForm.valid) {
      Auth.confirmSignUp(this.cognitoUser.user.username, this.confirmationModel.code).then(
        () => {
          // confirmation success
          this.cognitoUser = null;
          this.router.navigate(['/auth/login'])
        }
      ).catch(
        (error: any) => {
          this.authError = error.response.message;
        }
      )
    }
  }
}
